import ContractStatusesEnum from '../../../enums/profiles/contract-statuses.enum';

class SaveProfileContractDto {
  contractStatus!: ContractStatusesEnum;
  contractNotes?: string;
}

export default SaveProfileContractDto;
